import React from "react";
import { useQuery } from "react-query";
import { statistics } from "../../api/statistics";
import { useGlobalStore } from "../../store";
import { TableColumn } from "../common/Table/TableTypes";
import moment from "moment";
import Table from "../common/Table/Table";

interface ForceUpdateDriversAndVehiclesListProps {
  id: string;
  companyId?: number;
  setCompanyId: (id: number) => void;
}

const ForceUpdateDriversAndVehiclesList: React.FC<
  ForceUpdateDriversAndVehiclesListProps
> = ({ id, setCompanyId, companyId }) => {
  const selectedCompany = useGlobalStore((state) => state.selectedCompany);

  const { data, isLoading, isFetching } = useQuery(
    `fetchDriversAndVehicles-${selectedCompany}-${id}`,
    () => statistics.getDriversAndVehiclesById(id, selectedCompany),
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  const companyColumns: TableColumn<any>[] = [
    { header: "#", accessor: "num" },
    {
      header: "Name",
      accessor: "name",
      minWidth: "200px",
      clickRow: (item: any) => setCompanyId(item.id),
    },
    {
      header: "Date",
      accessor: "createdAt",
      minWidth: "200px",
    },
  ];

  const driverColumns: TableColumn<any>[] = [
    { header: "#", accessor: "num" },
    {
      header: "Android",
      accessor: "android",
      minWidth: "200px",
    },
    {
      header: "IOS",
      accessor: "ios",
      minWidth: "200px",
    },
    {
      header: "Drivers",
      accessor: "driver",
      minWidth: "200px",
    },
    {
      header: "Date",
      accessor: "createdAt",
      minWidth: "200px",
    },
  ];

  return (
    <div>
      <div className="title-1" style={{ padding: "4px 24px" }}>
        {companyId ? "Drivers" : "Companies"}
      </div>
      {data &&
        (companyId ? (
          <Table
            columns={driverColumns}
            data={
              data?.companies.find((c: any) => c.id === companyId)?.users || []
            }
            renderRow={(item: any, column: any, rowIndex: any) => {
              if (column.accessor === "num") {
                return <>{rowIndex + 1}</>;
              }
              if (column.accessor === "android") {
                return data?.requestData?.androidVersionCode;
              }
              if (column.accessor === "ios") {
                return data?.requestData?.iosVersionCode;
              }
              if (column.accessor === "createdAt") {
                return (
                  <>{moment(data.createdAt).format("MMM D, YYYY hh:mm A")}</>
                );
              }
              if (column.accessor === "driver") {
                return `${item.first_name} ${item.second_name}`;
              }
              return item[column.accessor];
            }}
            isLoading={isLoading || isFetching}
          />
        ) : (
          <Table
            columns={companyColumns}
            data={data?.companies}
            renderRow={(item: any, column: any, rowIndex: any) => {
              if (column.accessor === "num") {
                return <>{rowIndex + 1}</>;
              }
              if (column.accessor === "createdAt") {
                return (
                  <>{moment(data.createdAt).format("MMM D, YYYY hh:mm A")}</>
                );
              }
              if (column.accessor === "name") {
                return (
                  <>
                    {item.name}{" "}
                    <span style={{ color: "oklch(48.8% 0.243 264.376)" }}>
                      ({data?.userCount})
                    </span>
                  </>
                );
              }
              return item[column.accessor];
            }}
            isLoading={isLoading || isFetching}
          />
        ))}
    </div>
  );
};

export default ForceUpdateDriversAndVehiclesList;
